import React from 'react';

const Backdrop = (props) => (
    <div className ="backdrop" onClick={props.click}/>
)

export default Backdrop;